// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  lifeKey: __t.string().primaryKey().name("life_key"),
  campaignId: __t.u64().name("campaign_id"),
  rosterKey: __t.string().name("roster_key"),
  kind: __t.string(),
  side: __t.u8(),
  slot: __t.u32(),
  life: __t.u32(),
  hp: __t.f64(),
  hpMax: __t.f64().name("hp_max"),
  seq: __t.u32(),
  lastBy: __t.string().name("last_by"),
  endedAt: __t.timestamp().name("ended_at"),
  endCause: __t.string().name("end_cause"),
  version: __t.u32(),
  updatedAt: __t.timestamp().name("updated_at"),
});
